import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import PublicNavbar from "../components/PublicNavbar";
import { api, formatEUR, formatDateFR, photoUrl } from "../lib/api";
import { CheckCircle2, Loader2, Calendar, MapPin, Phone, Mail, User } from "lucide-react";

export default function Confirmation() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/bookings/${id}`).then(({ data }) => setData(data)).finally(() => setLoading(false));
  }, [id]);

  if (loading) {
    return (
      <div className="min-h-screen bg-white">
        <PublicNavbar />
        <div className="py-32 flex justify-center"><Loader2 className="h-6 w-6 animate-spin text-violet-600" /></div>
      </div>
    );
  }
  if (!data) return null;
  const { booking, vehicle } = data;

  return (
    <div className="min-h-screen bg-slate-50">
      <PublicNavbar />
      <div className="max-w-3xl mx-auto px-5 sm:px-8 py-12 sm:py-16">
        <div className="bg-white rounded-3xl border border-slate-200 p-8 sm:p-12 text-center" data-testid="confirmation-card">
          <div className="mx-auto h-16 w-16 rounded-full bg-violet-100 text-violet-600 flex items-center justify-center">
            <CheckCircle2 className="h-8 w-8" />
          </div>
          <div className="overline mt-6">Réservation confirmée</div>
          <h1 className="font-heading text-3xl sm:text-4xl font-medium tracking-tight text-slate-900 mt-2">
            Merci {booking.client_name.split(" ")[0]} !
          </h1>
          <p className="text-slate-600 mt-3">Votre réservation <span className="font-mono text-slate-900">#{booking.id.slice(0, 8).toUpperCase()}</span> a bien été enregistrée.</p>
        </div>

        <div className="mt-6 grid sm:grid-cols-2 gap-4">
          <div className="bg-white rounded-2xl border border-slate-200 p-6 flex gap-4">
            <div className="h-20 w-28 rounded-xl overflow-hidden bg-slate-100 shrink-0">
              <img src={photoUrl(vehicle?.photos?.[0])} alt="" className="h-full w-full object-cover" />
            </div>
            <div className="min-w-0">
              <div className="text-xs text-slate-500">{vehicle?.category_label || ""}</div>
              <div className="font-heading font-medium text-slate-900 truncate">{booking.vehicle_name}</div>
              <div className="text-xs text-slate-500 flex items-center gap-1 mt-1"><MapPin className="h-3 w-3" /> {vehicle?.city}</div>
            </div>
          </div>
          <div className="bg-white rounded-2xl border border-slate-200 p-6">
            <div className="overline mb-2">Résumé</div>
            <div className="space-y-2 text-sm">
              <div className="flex justify-between"><span className="text-slate-500">Durée</span><span className="font-medium">{booking.days} jour{booking.days > 1 ? "s" : ""}</span></div>
              <div className="flex justify-between"><span className="text-slate-500">Dates</span><span className="font-medium">{formatDateFR(booking.start_date)} → {formatDateFR(booking.end_date)}</span></div>
              <div className="flex justify-between pt-2 border-t border-slate-200"><span className="font-semibold">Total payé</span><span className="font-heading text-xl font-medium">{formatEUR(booking.total)}</span></div>
            </div>
          </div>
        </div>

        <div className="mt-6 bg-white rounded-2xl border border-slate-200 p-6">
          <div className="overline mb-4">Vos informations</div>
          <div className="grid sm:grid-cols-2 gap-4 text-sm">
            <div className="flex items-center gap-3"><User className="h-4 w-4 text-slate-400" /><span>{booking.client_name}</span></div>
            <div className="flex items-center gap-3"><Mail className="h-4 w-4 text-slate-400" /><span>{booking.client_email}</span></div>
            <div className="flex items-center gap-3"><Phone className="h-4 w-4 text-slate-400" /><span>{booking.client_phone}</span></div>
            <div className="flex items-center gap-3"><Calendar className="h-4 w-4 text-slate-400" /><span>Réservé le {formatDateFR(booking.created_at.substring(0, 10))}</span></div>
          </div>
        </div>

        <div className="mt-8 flex flex-wrap gap-3 justify-center">
          <Link to="/" className="px-6 py-3 rounded-full btn-primary text-sm font-medium">
            Retour à l'accueil
          </Link>
        </div>
      </div>
    </div>
  );
}
